import { Stack } from '@mui/material';

import { api, isDefined } from 'common';

import { useSchedulingConfigsField } from './hooks/useSchedulingConfigsField';
import { useFlowDefinitionContext } from '../../../../../context';
import { useReactFlowViewContext } from '../../../../context/context';
import { BlockAutocomplete } from '../../../ConfigFields/Autocomplete';
import { SearchableProviderPicker } from '../../../ConfigFields/Autocomplete/SearchableProviderPicker';
import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockSelectField } from '../../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';

interface SchedulingConfigsProviderBlockProps {
  fieldNamePrefix: string;
}

const { FormBlockProviderType } = api.FlowDefinition;

export function SchedulingConfigsProviderBlock(props: SchedulingConfigsProviderBlockProps) {
  const { fieldNamePrefix } = props;
  const { value: schedulingConfigsValue } = useSchedulingConfigsField(fieldNamePrefix);
  const { value: providerType } = useSelectedNodeField<api.FlowDefinition.FormBlockProviderType>(
    `${fieldNamePrefix}.providerType`
  );
  const { isEditable } = useReactFlowViewContext();
  const {
    flowDefinition: { organizationId },
  } = useFlowDefinitionContext();

  if (!isDefined(schedulingConfigsValue)) {
    return null;
  }

  return (
    <Stack gap={1}>
      <BlockSelectField
        fieldName={`${fieldNamePrefix}.providerType`}
        label="Provider Type"
        options={[
          { label: 'Static List', value: FormBlockProviderType.StaticList },
          { label: 'Dynamic List', value: FormBlockProviderType.DynamicList },
          { label: 'Interpolated', value: FormBlockProviderType.Interpolated },
        ]}
      />
      {providerType === FormBlockProviderType.StaticList && (
        <SearchableProviderPicker
          fieldName={`${fieldNamePrefix}.providerIds`}
          label="Providers"
          organizationId={organizationId}
          helperText="Enter provider ID for the appointment."
        />
      )}
      {providerType === FormBlockProviderType.DynamicList && (
        <BlockAutocomplete
          fieldName={`${fieldNamePrefix}.fhirDynamicProviders`}
          label="Providers"
          options={Object.values(api.PrevisitFormTemplateFieldConfig.FhirDynamicProviderKind)}
          multiple
          disabled={!isEditable}
          helperText="Select a dynamic provider from the list"
        />
      )}
      {providerType === FormBlockProviderType.Interpolated && (
        <BlockValueTemplateField
          fieldName={`${fieldNamePrefix}.interpolatedProvider`}
          label="Interpolated Provider"
          helperText="Write the interpolated variable. e.g. {{blockName.data.field}}"
        />
      )}
    </Stack>
  );
}
